jQuery(document).ready(function(){
    initBrowserCheck();
    initSlickCarousel();
    nav();
    initlanguageflags();
    initMenuScroll();
    initModal();
});

// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if ( isIE() ) {
        jQuery('.notice-browser').show();
    }
}

// Init Slick Carousel
function initSlickCarousel() {
}

function nav() {
    jQuery('.mobile-burger').on('click', function() {
        jQuery('.mobile-menu').toggleClass('show');
        jQuery('body').toggleClass('bodyopen');
        jQuery('.header-fixed').toggleClass('padding20');
        jQuery('.burger').toggleClass('show');
        jQuery('.close').toggleClass('show');
    });
}

function initlanguageflags() {
    jQuery('.lang-item-de').find('img').attr('src', 'https://proparin.com/wp-content/themes/proparin/images/Deutsch.svg');
    jQuery('.lang-item-en').find('img').attr('src', 'https://proparin.com/wp-content/themes/proparin/images/Englisch.svg');
}


function initMenuScroll() {
    jQuery(window).on('scroll', function() {
        if( jQuery(window).scrollTop() > 100 ) {
            jQuery('.front_logo').addClass('logo-scroll');
        }
        if( jQuery(window).scrollTop() < 100 ) {
            jQuery('.front_logo').removeClass('logo-scroll');
        }
    });
}

function initModal() {
    // Close overlay and set cookie
    jQuery('.patent').click( function() {
        jQuery(this).next('.modal').fadeIn();
    });
    // Close overlay and set cookie
    jQuery('.test').click( function() {
        jQuery(this).next('.modal').fadeIn();
    });

    // Close overlay and set cookie
    jQuery('.modal .close').click( function() {
        jQuery(this).closest('.modal').fadeOut();
    });

}